import { Component, inject } from '@angular/core';
import { KeycloakService } from 'keycloak-angular';

@Component({
  selector: 'syn-unauthorized',
  templateUrl: './unauthorized.component.html',
  styleUrls: ['./unauthorized.component.scss'],
})
export class UnauthorizedComponent {
  private keycloakService = inject(KeycloakService);

  logout(): void {
    this.keycloakService.logout(window.location.origin);
  }
}
